import { serviceHost } from "../../common/const";
import ServiceRequest from "../../utils/service-request";

export const searchUsers = async (user) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/usersSearch",
      user
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const updateUsers = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/usersSearch/update",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const getCompanyNames = async (value) => {
  try {
    let data = { value };
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/usersSearch/getCompanyNames",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const increaseToken = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/usersSearch/increaseToken",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};
